import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/no-address.svg'


const _hoisted_1 = {
  key: 0,
  class: "w-full py-4 mb-8 bg-white rounded-lg border border-gray-lp-1400 flex-col justify-start items-center gap-4 inline-flex"
}
const _hoisted_2 = { class: "justify-between items-center inline-flex w-full px-4" }
const _hoisted_3 = { class: "text-black-lp-300 text-base font-semibold" }
const _hoisted_4 = { class: "justify-start items-center gap-4 flex" }
const _hoisted_5 = { class: "text-center text-xs font-semibold" }
const _hoisted_6 = { class: "text-center text-xs font-semibold" }
const _hoisted_7 = { class: "justify-start items-center gap-2 inline-flex w-full border-t px-4 pt-4" }
const _hoisted_8 = {
  key: 0,
  class: "grow shrink basis-0 flex-col justify-center items-center gap-2 inline-flex w-full"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "no-address",
  class: "h-20"
}, null, -1)
const _hoisted_10 = { class: "flex-col justify-start items-start flex" }
const _hoisted_11 = { class: "text-center text-gray-lp-600 text-base font-normal" }
const _hoisted_12 = {
  key: 1,
  class: "grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex"
}
const _hoisted_13 = { class: "self-stretch justify-between items-center inline-flex" }
const _hoisted_14 = { class: "justify-start items-center gap-2 flex" }
const _hoisted_15 = {
  key: 0,
  class: "px-2 bg-gray-lp-1400 rounded justify-center items-center gap-2 flex"
}
const _hoisted_16 = { class: "text-center text-black-lp-300 text-sm font-medium" }
const _hoisted_17 = { class: "text-left text-black-lp-300 text-sm font-bold" }
const _hoisted_18 = { class: "flex-col justify-start items-start gap-4 flex" }
const _hoisted_19 = { class: "flex-col justify-start items-start gap-1 flex" }
const _hoisted_20 = { class: "text-left" }
const _hoisted_21 = { class: "text-black-lp-300 text-sm font-semibold" }
const _hoisted_22 = { class: "text-black-lp-300 text-sm font-normal" }
const _hoisted_23 = { class: "flex-col justify-start items-start gap-1 flex" }
const _hoisted_24 = { class: "text-gray-lp-1800 text-sm font-medium" }
const _hoisted_25 = { class: "text-gray-lp-1800 text-sm font-medium" }
const _hoisted_26 = { class: "justify-start items-center gap-1 inline-flex" }
const _hoisted_27 = { class: "text-black-lp-300 text-sm font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (!_ctx.loading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("pickupCorporate.addressPickUp")), 1),
          _createVNode("div", _hoisted_4, [
            (!_ctx.selectedAddress.pcaName)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "rounded-md justify-center items-center flex text-red-lp-100 gap-1 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClickTambahAlamat')))
                }, [
                  _createVNode(_component_Icons, {
                    name: "plus",
                    class: "h-4"
                  }),
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("pickupCorporate.addAddress")), 1)
                ]))
              : (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "rounded-md justify-center items-center flex text-red-lp-100 gap-1 cursor-pointer",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onClickPilihAlamatLain')))
                }, [
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("pickupCorporate.selectOtherAddress")), 1),
                  _createVNode(_component_Icons, {
                    name: "chevron-right",
                    class: "h-4"
                  })
                ]))
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          (!_ctx.selectedAddress.pcaName)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("pickupCorporate.noAddressSaved")), 1)
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    (_ctx.selectedAddress.pcaIsDefault)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("pickupCorporate.utama")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.selectedAddress.pcaName), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("span", _hoisted_21, _toDisplayString(_ctx.selectedAddress.pcaPicName), 1),
                      _createVNode("span", _hoisted_22, " - " + _toDisplayString(_ctx.selectedAddress.pcaPhoneNumber), 1)
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, _toDisplayString(_ctx.selectedAddress.pcaDistrict.name), 1),
                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.selectedAddress.pcaAddress), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode(_component_Icons, {
                      name: "location-pin",
                      class: "h-4 text-red-lp-100"
                    }),
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("pickupCorporate.coordLabel")) + " : " + _toDisplayString(_ctx.selectedAddress.pcaLatlon), 1)
                  ])
                ])
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}